import { useState } from 'react';

/***
 * A reusable hook implementing the "controllable"-pattern, but with hooks =)
 * https://medium.com/quick-code/writing-ui-components-with-optionally-controllable-state-86e396a6f1ec
 *
 * The controllable-pattern allows a component to work both in controlled and uncontrolled mode
 * @param value
 * @param changeHandler
 * @param initialValue
 * @returns {*[]}
 */
export function useControllableState<T>(
  value: undefined | T,
  changeHandler: undefined | ((value: T) => void),
  initialValue: T
): [T, (newValue: T) => void] {
  const [stateValue, setState] = useState(initialValue);
  const effectiveValue = value !== undefined ? value : stateValue;
  return [
    effectiveValue,
    (newValue: T) => {
      setState(newValue);
      if (changeHandler) {
        changeHandler(newValue);
      }
    },
  ];
}
